import React, { useState } from 'react';
import { Form, Form } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';
import { FaTrash, FaTrash } from 'react-icons/fa';

export const ExtraTimeSlots = ({
  scheduleDuration,
  extraStartTimes,
  setExtraStartTimes,
  baseMinute = 0,
}) => {
  const addNewStartTime = () => {
    // Default to 12:00 AM (00:00) with the baseMinute
    const formattedMinute = String(baseMinute).padStart(2, '0');
    const defaultTime = `00:${formattedMinute}`;
    setExtraStartTimes([...extraStartTimes, defaultTime]);
  };

  const getEndTime = (startTime) => {
    if (!scheduleDuration || !startTime) return '';
    const [hours, minutes] = startTime.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes + Number(scheduleDuration);
    let endHours = Math.floor(totalMinutes / 60) % 24;
    let endMinutes = totalMinutes % 60;
    return `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
  };

  const handleHourChange = (index, hour12, ampm) => {
    const newTimes = [...extraStartTimes];
    const formattedMinute = String(baseMinute).padStart(2, '0');
    // Convert 12-hour to 24-hour
    let hour24 = hour12;
    if (ampm === 'PM' && hour12 !== 12) {
      hour24 = hour12 + 12;
    } else if (ampm === 'AM' && hour12 === 12) {
      hour24 = 0;
    }
    newTimes[index] = `${String(hour24).padStart(2, '0')}:${formattedMinute}`;
    setExtraStartTimes(newTimes);
  };

  const getHour12FromTime = (timeString) => {
    if (!timeString || !timeString.includes(':')) return 12;
    const hour24 = parseInt(timeString.split(':')[0], 10);
    if (hour24 === 0) return 12;
    if (hour24 > 12) return hour24 - 12;
    return hour24;
  };

  const getAmPmFromTime = (timeString) => {
    if (!timeString || !timeString.includes(':')) return 'AM';
    const hour24 = parseInt(timeString.split(':')[0], 10);
    return hour24 >= 12 ? 'PM' : 'AM';
  };

  return (
    <div>
      {extraStartTimes.map((startTime, index) => (
        <div key={index} className="d-flex flex-row mb-3">
          <div className="flex d-flex align-items-center w-50">
            <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
              <Form.Select
                value={getHour12FromTime(startTime)}
                onChange={(e) => {
                  const hour = parseInt(e.target.value, 10);
                  handleHourChange(index, hour, getAmPmFromTime(startTime));
                }}
                className="bg-primary text-white border-secondary"
                style={{ width: '70px' }}
              >
                {[...Array(12)].map((_, i) => {
                  const hour = i + 1;
                  return (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  );
                })}
              </Form.Select>
              <span className="text-white">:</span>
              <Form.Control
                type="text"
                value={String(baseMinute).padStart(2, '0')}
                disabled
                readOnly
                className="bg-primary text-white border-secondary opacity-50"
                style={{ width: '60px' }}
              />
              <Form.Select
                value={getAmPmFromTime(startTime)}
                onChange={(e) => {
                  handleHourChange(index, getHour12FromTime(startTime), e.target.value);
                }}
                className="bg-primary text-white border-secondary"
                style={{ width: '90px' }}
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </Form.Select>
            </div>
            <span className="mx-2 text-white">to</span>
          </div>
          <div className="flex d-flex align-items-center w-50">
            <Form.Control
              type="time"
              value={getEndTime(startTime)}
              readOnly
              placeholder="End"
              className="bg-primary text-white border-secondary opacity-50"
              style={{}}
              disabled={true}
            />
            <button
              type="button"
              aria-label="Delete time slot"
              className="btn btn-link text-danger ms-2 p-0 d-flex align-items-center"
              style={{ fontSize: '1.3rem' }}
              onClick={() => {
                const newTimes = extraStartTimes.filter((_, i) => i !== index);
                setExtraStartTimes(newTimes);
              }}
            >
              <BsTrash size={20} className="text-danger" aria-hidden="true" />
            </button>
          </div>
        </div>
      ))}
      {scheduleDuration !== 1439 && (
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary mt-2"
            style={{ minWidth: 140 }}
            onClick={addNewStartTime}
          >
            + Add Time Slot
          </button>
        </div>
      )}
    </div>
  );
};
